import { render, staticRenderFns } from "./QuestionH5.vue?vue&type=template&id=021ed55c&"
import script from "./QuestionH5.vue?vue&type=script&lang=js&"
export * from "./QuestionH5.vue?vue&type=script&lang=js&"
import style0 from "./QuestionH5.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports